var r = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e.Large = "large", e))(r || {}), l = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Info = "info", e.Success = "success", e.Warning = "warning", e.Danger = "danger", e.Alternate = "alternate", e))(l || {}), d = /* @__PURE__ */ ((e) => (e.Filled = "filled", e.Outline = "outline", e))(d || {});
export {
  r as SizesEnum,
  l as VariantsEnum,
  d as VariationsEnum
};
